import React from 'react';
import { useIntl } from 'react-intl';

import {
  FooterMode,
  WizardScreen
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { WizardFinished } from '@futrli/ui-components/components/sidebar/wizard/wizard-finished/wizard-finished';

export interface DashboardDuplicatedWizardScreenProps {
  onClose: () => void;
  onView: () => void;
}

export const DashboardDuplicatedWizardScreen = ({ onClose, onView }: DashboardDuplicatedWizardScreenProps) => {
  const intl = useIntl();

  const viewText = intl.formatMessage({
    id: 'predict.dashboards.go_to_dashboard',
    defaultMessage: 'Go to dashboard'
  });

  return (
    <WizardScreen footerMode={FooterMode.CREATED} onCancel={onClose} onView={onView} viewText={viewText}>
      <WizardFinished
        text={intl.formatMessage({
          id: 'predict.dashboards.dashboard_duplicated_and_saved_as_a_draft',
          defaultMessage: 'Dashboard created and saved as a draft for review'
        })}
      />
    </WizardScreen>
  );
};
